import {TagIcon} from '@primer/octicons-react'
import styles from './Releases.module.css'
import conversationStyles from './ConversationList.module.css'
import type {InfographicDataPoint} from '../types'
import {pluralize, createRelativeTimeProps} from '../helpers/infographic-helpers'
import {Link, RelativeTime} from '@primer/react'

interface ReleasesSectionProps {
  count?: number
  peopleCount?: number
  releases?: InfographicDataPoint[]
}

const DEFAULT_RELEASES: ReleasesSectionProps['releases'] = []

export function Releases({count = 0, peopleCount = 0, releases = DEFAULT_RELEASES}: ReleasesSectionProps) {
  const Icon = TagIcon
  const iconClass = 'color-default'
  const title = `${pluralize(count, 'release', 'releases')} published`
  const sectionId = 'releases'

  return releases && releases.length > 0 ? (
    <section className={styles.section}>
      <div>
        <h3 className={conversationStyles.conversationListHeading} id={sectionId}>
          <span className={conversationStyles.inner}>
            <Icon className={iconClass} /> <strong className="color-fg-default">{count}</strong> {title} by{' '}
            <strong className="color-fg-default">{peopleCount}</strong> {pluralize(peopleCount, 'person', 'people')}
          </span>
        </h3>
      </div>

      <ul className="list-style-none tmp-my-4">
        {releases &&
          releases.map(release => (
            <li key={release.number} className="clearfix">
              <Icon className={`${iconClass} float-left mt-1`} />
              <div className="overflow-hidden pl-2">
                <Link href={release.path} className="h4 Link--primary mb-1 markdown-title">
                  {release.number} {release.title}
                </Link>
                <p className="color-fg-muted text-small">
                  <RelativeTime {...createRelativeTimeProps(release.createdAt)} />
                </p>
              </div>
            </li>
          ))}
      </ul>
    </section>
  ) : null
}
